<template>
  <div :class="['password-base', displayLayout, newClass, isNewClass]">
    <!-- 密码输入框 -->
    <van-password-input
      :value="password"
      :mask="!numVisible"
      :length="6"
      :gutter="gutter"
      :focused="show"
      @focus="setShowKeyboard(true)"
    />
    <!-- 数字键盘 -->
    <van-number-keyboard
      v-model="password"
      :show="show"
      @blur="setShowKeyboard(false)"
    />
  </div>
</template>
<script>
  import Vue from 'vue'
  import { mapGetters } from 'vuex'
  import { PasswordInput, NumberKeyboard } from 'vant'
  import '@vant/touch-emulator'

  Vue.use(PasswordInput)
  Vue.use(NumberKeyboard)

  // 输入密码
  export default {
    name: 'password-base',
    props: {
      value: [Number, String],
      showKeyboard: [Boolean],
      showKeyboardKey: {
        type: [String],
        default: '',
      },
      gutter: {
        type: [String, Number],
        default: '0',
      },
      numVisible: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        show: this.showKeyboard,
        password: this.value,
      }
    },
    computed: {
      ...mapGetters(['displayLayout', 'isNewClass']),
      newClass() {
        // 是否是钱包的新页面
        const name = this.$route.name
        return name === 'password-edit' ? '' : 'new-wallet'
      },
    },
    watch: {
      value(val) {
        this.password = val
      },
      showKeyboard(val) {
        this.show = val
      },
      password(val) {
        // 超过6位时,去掉多余的数字
        let value = val
        if (val.length > 6) {
          value = val.slice(0, 6)
          this.password = value
        }
        this.$emit('input', value)
      },
    },
    methods: {
      setShowKeyboard(value) {
        const { showKeyboardKey } = this
        if (showKeyboardKey) {
          this.$emit('setShowKeyboard', { showKeyboardKey, value })
        } else {
          this.show = value
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .van-password-input {
    margin: 0;

    // .van-password-input__security li.van-password-input__item {
    //   border: 1px solid #f9f9f9;
    //   border-radius: 12px;
    //   width: 50px;
    //   min-height: 50px;
    //   margin: 0 10px;
    // }
  }
  .van-number-keyboard {
    padding-top: 12px;
    ::v-deep .van-number-keyboard__body {
      padding: 6px 10px 0 16px; //键盘方格间距为6px
    }
    ::v-deep .van-key__wrapper {
      & > div.van-key {
        // 确保键盘方格固定长宽比
        position: relative;
        height: 0;
        padding-top: 20%;
        padding-bottom: 20%;
      }
    }
  }
  .password-base.gt-layout {
    .van-number-keyboard {
      padding-bottom: 6px; // 键盘 van-number-keyboard__body 内边距 6px
    }
  }
  .password-base.desktop-layout {
    .van-number-keyboard {
      width: 414px;
      position: absolute;
      left: 0;
      bottom: 0;
      padding-top: 12px;
    }
  }

  .password-base.new-wallet.is-new {
    .van-password-input__item {
      background: $white-1;
      border-radius: 12px;
      border: none;
      color: $orange;
      .van-password-input__cursor {
        background-color: $orange;
      }
    }
    .van-password-input__security i {
      background-color: $orange;
    }

    .van-number-keyboard {
      background-color: #363b3f;
    }
  }

  .email-change-container {
    .password-base.email-code {
      .van-password-input {
        ::v-deep .van-password-input__item {
          background-color: rgba(113, 113, 113, 0.1);
          border-radius: 12px;
        }
      }
    }
  }
</style>
